// extracted by mini-css-extract-plugin
module.exports = {"mainReviewsWrapper":"pl"};